{
  "id": "kabuki-east", "light": 0.6,
  "_note": "2x art scene: Kabukicho east edge toward Okubo (x114-127, y10-55). Cosmetic only; see kabuki-crossing.json for the field meanings.",
  "rect": { "x": 114, "y": 10, "w": 14, "h": 46 },
  "buildings": [
    { "id": "ke-bar", "x": 122, "y": 12, "w": 6, "h": 4, "face": 2, "kind": "bar", "roof": "tar",
      "sign": { "text": "バー", "color": "cyan" }, "props": [["kabukiEastBoard", 0.8, 0.2], ["ac", 4.4, 0.6]] },
    { "id": "ke-hotel", "x": 122, "y": 16, "w": 6, "h": 6, "face": 3, "kind": "hotel", "roof": "concrete",
      "sign": { "text": "ホテル", "color": "pink" }, "props": [["tank", 3.8, 0.5], ["ac", 0.6, 1.4], ["ac", 1.9, 1.4], ["vent", 4.4, 2.1]] },
    { "id": "ke-snack", "x": 122, "y": 22, "w": 6, "h": 6, "face": 3, "kind": "kabukiEastSnack", "roof": "ribbed",
      "props": [["ac", 0.6, 0.6], ["ac", 1.9, 0.6], ["dish", 4.4, 0.8], ["duct", 0.8, 2.2, 4.8, 2.2]] },
    { "id": "ke-park", "x": 122, "y": 36, "w": 6, "h": 6, "face": 3, "kind": "kabukiEastParking", "roof": "kabukiEastDeck",
      "props": [["hut", 4.6, 0.3]] },
    { "id": "ke-flats", "x": 122, "y": 42, "w": 6, "h": 6, "face": 2, "kind": "apartment", "roof": "ribbed",
      "props": [["ac", 0.6, 0.8], ["ac", 2, 0.8], ["tank", 4, 1.4], ["vent", 1.4, 3.2]] },
    { "id": "ke-laundry", "x": 122, "y": 48, "w": 6, "h": 6, "face": 3, "kind": "kabukiEastLaundry", "roof": "concrete",
      "props": [["ac", 0.6, 0.5], ["vent", 3, 1.2], ["skylight", 3.6, 0.6]] }
  ],
  "lamps": [
    [115.6, 14, "e"], [115.6, 22, "e"], [115.6, 40, "e"], [115.6, 48, "e"],
    [120.4, 14, "w"], [120.4, 22, "w"], [120.4, 40, "w"], [120.4, 48, "w"],
    [124, 29.6, "s"], [124, 34.5, "n"]  ]
}
